import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { CrudService } from "./crud.service";
import { RubroContable, SearchRubroContableRequest, SaveRubroContableDto } from "../model/rubroContable";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { GenericResponse } from '../model';

@Injectable({
    providedIn: 'root'
})
export class RubroContableService extends CrudService<RubroContable, number, SaveRubroContableDto, SearchRubroContableRequest> {

    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
        super(_http, 'RubroContable', sharedFunctions);

    }

    getAll(): Observable<GenericResponse<RubroContable[]>> {
        return this._http.get<GenericResponse<RubroContable[]>>(this._serviceUrl + '', this.httpOptions);
    }
}